
// src/actions/upload-file.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const UPLOAD_FILE = "UPLOAD_FILE"
export const UPLOAD_FILE_REQUESTED = "UPLOAD_FILE_REQUESTED"
export const UPLOAD_FILE_COMPLETED = "UPLOAD_FILE_COMPLETED"
export const UPLOAD_FILE_FAILED = "UPLOAD_FILE_FAILED"
export const UPLOAD_FILE_PROGRESS = "UPLOAD_FILE_PROGRESS"
export const CANCEL_UPLOAD_FILE = "CANCEL_UPLOAD_FILE"
export const CLEAR_UPLOAD_FILES_AND_VIDEOS = "CLEAR_UPLOAD_FILES_AND_VIDEOS"

// 最大アップロードファイルサイズを設定します。この値はnginxの制限に依存しています。
// 現在nginxの最大アップロードファイルサイズは1000MBに設定されています。
const MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024; // 1000MB in bytes
const MAX_FILE_SIZE_TITLE = "1000MB" // Max file size displayed in error message

export function uploadFileRequested(componentId, uploadId) {
  return {
    type: UPLOAD_FILE_REQUESTED,
    componentId, uploadId,
  }
}

export function uploadFileProgress(loaded, total, componentId, uploadId) {
  return {
    type: UPLOAD_FILE_PROGRESS,
    loaded, total, componentId, uploadId
  }
}

export function uploadFile(id, type, file, componentId, single = false) {
  var uploadId = Math.random().toString().slice(-12)
  return function(dispatch) {
    dispatch(uploadFileRequested(componentId, uploadId))
    return api.upload(`/upload_file`, { [type + '_id']: id }, file, (progress)=> {
          dispatch(uploadFileProgress(progress.loaded, progress.total, componentId, uploadId))
        })
        .then((results)=> {
          dispatch(uploadFileCompleted(results, componentId, uploadId, single))
        })
        .catch((error)=> {
          // Check if file size is over MAX_FILE_SIZE
          if (file.size > MAX_FILE_SIZE) {
            Promise.all([
              dispatch(uploadFileFailed(error, componentId, uploadId)),
              dispatch(emitAlertMessage({ message: 'error:ファイルサイズが制限を超えています', max_file_size: MAX_FILE_SIZE_TITLE }, 'error'))
            ])
          } else {
            Promise.all([
              dispatch(uploadFileFailed(error, componentId, uploadId)),
              dispatch(emitAlertMessage(error, 'error'))
            ])
          }
        })
  }
}

export function uploadFileCompleted(results, componentId, uploadId, single) {
  return {
    type: UPLOAD_FILE_COMPLETED,
    results, componentId, uploadId, single,
  }
}

export function uploadFileFailed(error, componentId, uploadId) {
  return {
    type: UPLOAD_FILE_FAILED,
    error, componentId, uploadId,
  }
}

export function cancelUploadFile(componentId, uploadId) {
  return {
    type: CANCEL_UPLOAD_FILE,
    componentId, uploadId,
  }
}

export function clearUploadFilesAndVideos(componentId) {
  return {
    type: CLEAR_UPLOAD_FILES_AND_VIDEOS,
    componentId,
  }
}



// WEBPACK FOOTER //
// ./src/actions/upload-file.js